/*
 * Shared filter definitions for the device stat cards and the filter dropdown,
 * so selecting one keeps the other in sync.
 */

export type FilterKey = 'all' | 'offline' | 'online' | 'speed' | 'updates';

export interface FilterDef {
  key: FilterKey;
  /** Dropdown option label. */
  label: string;
  /** Stat card label. */
  cardLabel: string;
  /** Stat card dot color (none for "all"). */
  dot?: string;
}

export const FILTERS: FilterDef[] = [
  { key: 'all', label: 'All Devices', cardLabel: 'Devices' },
  { key: 'online', label: 'Online', cardLabel: 'Online', dot: 'rgb(53, 211, 153)' },
  { key: 'offline', label: 'Offline', cardLabel: 'Offline', dot: 'rgb(255, 80, 95)' },
  { key: 'updates', label: 'Updates', cardLabel: 'Updates', dot: 'rgb(242, 179, 61)' },
  { key: 'speed', label: 'Speed Alerts', cardLabel: 'Speed Alerts', dot: 'rgb(255, 80, 95)' }
];
